<div class="inbox-welcome">
    <div class="inbox-welcome__box">
        <h1>
            <ui-svg-icon svgIcon="inbox" size="xlarge"></ui-svg-icon>
            {{ 'smart_inbox.title' | translate }}
        </h1>
        <h3>{{ 'smart_inbox.connect_to_inbox.title.prefix' | translate }} <span class="ai-gradient">{{ 'smart_inbox.connect_to_inbox.title.suffix' | translate }}</span></h3>
        <p>{{ 'smart_inbox.connect_to_inbox.description' | translate }}</p>
        <ui-button [label]="'smart_inbox.connect_to_inbox.CTA' | translate" type="primary" [isLoading]="isLoading" [disabled]="isLoading" (click)="initializeConnectionWizard()"></ui-button>
        <small>{{ 'smart_inbox.connect_to_inbox.security_text' | translate }}</small>
    </div>
</div>
